'use client';

import { useBlockNumber as wagmiUseBlockNumber } from 'wagmi';

export function useBlockNumber() {
  const { data: blockNumber } = wagmiUseBlockNumber();
  return blockNumber;
}
